<template>
    <div style="background: #faf9f9;">
        <div class="page-wrap">
            <el-breadcrumb
                separator-class="el-icon-arrow-right"
                class="breadcrumb"
            >
                <el-breadcrumb-item>首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/' }"
                    >博物馆研学</el-breadcrumb-item
                >
                <el-breadcrumb-item>列表</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="listCard">
                <div class="listTop">
                    <div class="leftIpt">
                        <i class="el-icon-search"></i>
                        <el-input
                            placeholder="搜索线路、课程"
                            v-model="SearchName"
                            clearable
                            size="small"
                            class="inputs"
                        ></el-input>
                        <button @click="SearchFn">搜索</button>
                    </div>
                    <div class="rightOpt">
                        <el-select
                            v-model="className"
                            placeholder="分类"
                            @change="selectNave"
                            size="small"
                        >
                            <el-option
                                v-for="item in barList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.label"
                            >
                            </el-option>
                        </el-select>
                        <el-select
                            v-model="formType"
                            placeholder="形式"
                            @change="formTypeFn($event, 1)"
                            size="small"
                        >
                            <el-option
                                v-for="item in list1"
                                :key="item.value"
                                :label="item.label"
                                :value="item.label"
                            >
                            </el-option>
                        </el-select>
                        <el-select
                            v-model="ageGroup"
                            placeholder="年龄段"
                            @change="formTypeFn($event, 2)"
                            size="small"
                        >
                            <el-option
                                v-for="item in list2"
                                :key="item.value"
                                :label="item.label"
                                :value="item.label"
                            >
                            </el-option>
                        </el-select>
                        <el-select
                            v-model="territory"
                            placeholder="地域"
                            @change="formTypeFn($event, 3)"
                            size="small"
                        >
                            <el-option-group
                                v-for="group in list3"
                                :key="group.index"
                                :label="group.index"
                            >
                                <el-option
                                    v-for="item in group.Province"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                >
                                </el-option>
                            </el-option-group>
                        </el-select>
                        <el-select
                            v-model="chargeType"
                            placeholder="收费类型"
                            @change="formTypeFn($event, 4)"
                            size="small"
                        >
                            <el-option
                                v-for="item in list4"
                                :key="item.value"
                                :label="item.label"
                                :value="item.label"
                            >
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="listBot section-wrap">
                    <section
                        v-for="item in dataList"
                        :key="item._id"
                        class="one"
                    >
                        <div class="img-wrap">
                            <router-link
                                :to="
                                    '/detailPc?type=' +
                                    item.slefType +
                                    '&id=' +
                                    item._id
                                "
                            >
                                <img
                                    v-show="item.tempFileURL"
                                    :src="item.tempFileURL"
                                    alt=""
                                />
                            </router-link>
                        </div>
                        <div class="section-content">
                            <router-link
                                :to="
                                    '/detailPc?type=' +
                                    item.slefType +
                                    '&id=' +
                                    item._id
                                "
                            >
                                <div class="section-title">{{ item.Name }}</div>
                            </router-link>
                            <div>
                                <div
                                    class="section-tags tags"
                                    v-html="getAges(item)"
                                ></div>
                                <div class="section-museum">
                                    {{ item.Owner }}
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <loading
                    @getMore="loadingFn"
                    :loading="loading"
                    :isMore="isMore"
                    :hide="true"
                    :isPc="true"
                ></loading>
            </div>
        </div>
        <footer-pc></footer-pc>
    </div>
</template>

<script>
import FooterPc from "../components/FooterPc";
import Loading from "../components/Loading";
import { getIndexInfoList } from "../util/util";
export default {
    components: {
        FooterPc,
        Loading,
    },
    computed() {},
    data() {
        return {
            list1: [
                { value: 0, label: "不限" },
                { value: 1, label: "线路" },
                { value: 2, label: "课程" },
            ],
            list2: [
                { value: 0, label: "不限" },
                { value: 1, label: "小学1~3年级" },
                { value: 2, label: "小学4~6年级" },
                { value: 3, label: "中学" },
                { value: 4, label: "高中" },
            ],
            list3: [
                {
                    index: "-",
                    Province: ["全部省份"],
                },
                {
                    index: "A",
                    Province: ["安徽省", "澳门特别行政区"],
                },
                {
                    index: "B",
                    Province: ["北京市"],
                },
                {
                    index: "C",
                    Province: ["重庆市"],
                },
                {
                    index: "F",
                    Province: ["福建省"],
                },
                {
                    index: "G",
                    Province: ["甘肃省", "广东省", "贵州省"],
                },
                {
                    index: "H",
                    Province: [
                        "海南省",
                        "河北省",
                        "河南省",
                        "黑龙江省",
                        "湖北省",
                        "湖南省",
                    ],
                },
                {
                    index: "J",
                    Province: ["吉林省", "江苏省", "江西省"],
                },
                {
                    index: "L",
                    Province: ["辽宁省"],
                },
                {
                    index: "Q",
                    Province: ["青海省"],
                },
                {
                    index: "S",
                    Province: [
                        "山东省",
                        "山西省",
                        "陕西省",
                        "上海市",
                        "四川省",
                    ],
                },
                {
                    index: "T",
                    Province: ["台湾省", "天津市"],
                },
                {
                    index: "X",
                    Province: ["香港特别行政区"],
                },
                {
                    index: "Y",
                    Province: ["云南省"],
                },
                {
                    index: "Z",
                    Province: ["浙江省"],
                },
            ],
            list4: [
                { value: 0, label: "不限" },
                { value: 1, label: "付费" },
                { value: 2, label: "免费" },
            ],

            // label: "测试1",
            formType: "",
            ageGroup: "",
            territory: "",
            chargeType: "",
            barList: [
                { label: "全部", value: 0 },
                { label: "历史类", value: 1 },
                { label: "红色类", value: 2 },
                { label: "艺术类", value: 3 },
                { label: "自然类", value: 4 },
                { label: "民族民俗类", value: 5 },
                { label: "科技类", value: 6 },
            ],

            className: "全部",
            activeIndex: 0,
            SearchName: "",
            dataList: [],
            isMore: true,
            loading: true,
            page: 0,
        };
    },
    mounted() {
        var intersectionObserver = new IntersectionObserver((entries) => {
            // 如果不可见，就返回
            console.log(entries[0].intersectionRatio);
            if (
                entries[0].intersectionRatio <= 0 ||
                entries[0].intersectionRatio == 1
            )
                return;
            this.getListInfo();
            /* console.log("Loaded new items"); */
        });
        // 开始观察
        document.querySelectorAll(".loading").forEach((item) => {
            intersectionObserver.observe(item);
        });
    },
    created() {
        const index = this.$route.query.type;
        this.activeIndex = index;
        this.className = this.barList[index].label;
        this.getListInfo();
    },
    methods: {
        getAges(item) {
            let str = `<span class="tag">${
                item.slefType == "Roads" ? "线路" : "课程"
            }</span><span class="tag">${item.Class}</span>`;
            item.Age.split(",").map((age) => {
                str += `<span class="tag">${age}</span>`;
            });
            return str;
        },
        // 获取所有路线
        getAllRoads(params = {}) {
            const db = this.$TCB_App.database();
            const AllRoads = db.collection("DataBase_All_Roads");
            return AllRoads.orderBy("EditDate", "desc")
                .skip(this.$data.barList[this.activeIndex].page)
                .where(params)
                .get();
        },
        // 获取所有课程
        getAllCourse(params = {}) {
            const db = this.$TCB_App.database();
            const AllCourse = db.collection("DataBase_All_Course");
            return AllCourse.orderBy("EditDate", "desc")
                .skip(this.$data.barList[this.activeIndex].page)
                .where(params)
                .get();
        },
        SearchFn() {
            console.log(this.SearchName);
            this.page = 0;
            this.getListInfo();
        },
        // 形式
        formTypeFn(val, n) {
            console.log(val, n);
            switch (n) {
                case 1:
                    this.formType = val //== "不限" ? "" : val;
                    break;
                case 2:
                    this.ageGroup = val //== '不限' ? "" : val;
                    break;
                case 3:
                    if (val == "全部省份") {
                        this.territory = "全部省份";
                    }else if (val.indexOf("市") > -1) {
                        this.territory = val.substring(0,val.indexOf("市"));
                    } else {
                        this.territory = val;
                    }
                    break;
                case 4:
                    this.chargeType = val// == '不限' ? "" : val;
                    break;
            }
            this.page = 0;
            this.getListInfo();
        },
        loadingFn() {},
        getListInfo() {
            //this.page=0
            this.loading = true;
            this.isMore = false;
            let where = {};
            if (this.className != "全部") {
                where = {
                    Class: this.className,
                };
            }
            // 搜索
            // if (this.SearchName != "" && this.SearchName != "不限") {
            //     where.Name = this.SearchName;
            //     // where = Object.assign(where, { Name: this.SearchName });
            // }
            // 区域
            if (this.territory != "" && this.territory != "全部省份") {
                where.Province = this.territory;
            }
            // 收费类型
            if (this.chargeType != "" && this.chargeType != "不限") {
                where.Prices = this.chargeType;
            }
            this.dataList = [];
            // if (this.barList[this.activeIndex].falg) return;
            getIndexInfoList({
                $TCB_App: this.$TCB_App,
                limit: 20,
                where: where,
                skip: this.page,
            }).then((res) => {
                let list = [];
                // 根据筛选条件展示不同的内容，因为这里用的是两个库比较坑
                if (this.formType == "" || this.formType=='不限') {
                    list = res.flat(Infinity);
                } else if (this.formType == "线路") {
                    // 路线
                    list = res[0];
                } else {
                    // 课程
                    list = res[1];
                }

                if (list.length > 0) {
                    // 根据年龄段匹配 过滤list
                    if (this.ageGroup != "" && this.ageGroup != "不限") {
                        list = list.filter((item) => {
                            // 遍历年龄段
                            //console.log(item.Age.indexOf(this.ageGroup))
                            return item.Age.indexOf(this.ageGroup) > -1;
                        });
                    }
                    this.dataList = this.dataList.concat(list);
                    //this.page += 20;
                    
                    var newList = []
                    if(this.SearchName){
                        this.dataList.map((item)=>{
                            item.Name.includes(this.SearchName)?newList.push(item):''
                        })
                        console.log(newList)
                        this.dataList = newList
                    }
                    this.loading = false;
                }
                if (list.length < 20) {
                    this.loading = false;
                    this.isMore = false;
                }
            });
        },
        selectNave(val) {
            this.className = val;
            this.page = 0;
            this.getListInfo();
        },
    },
};
</script>

<style scoped lang="scss">
.page-wrap {
    background: #faf9f9;
    padding: 30px 20% 0;
    min-height: 100%;
}
.breadcrumb {
    margin-bottom: 10px;
    span {
        opacity: 0.8;
        font-size: 12px;
        color: #7288a6 !important;
        line-height: 12px;
    }
}
.listCard {
    background: #ffffff;
    border: 1px solid #e7edf6;
    box-shadow: 0 6px 14px 0 rgba(0, 0, 0, 0.02);
    border-radius: 4px;
    padding: 22px 20px 30px;
    .listTop {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .leftIpt {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            width: 300px;
            height: 30px;
            background: #ffffff;
            border: 1px solid #d2ddec;
            border-radius: 4px;
            > i {
                font-size: 12px;
                padding: 0 7px 0 10px;
            }
            button {
                font-size: 14px;
                color: #71a209;
                border: 0;
                outline: 0;
                background: 0;
                width: 50px;
                padding: 0;
            }
        }
    }
}
.box-wrap {
    padding: 2.667vw 4vw;
    background: #ffffff;
    .search-wrap {
        background: #fafafa;
        height: 9.333vw;
        border-radius: 8vw;
    }
}
nav {
    margin-top: 2.667vw;
    background: #ffffff;
    overflow-x: scroll;
    border-bottom: solid 0.133vw #eeeeee;
    ul {
        display: inline-block;
        padding: 0 4vw;
        margin: 0;
        white-space: nowrap;
        li {
            display: inline-block;
            list-style-type: none;
            text-align: center;
            height: 13.333vw;
            line-height: 13.333vw;
            font-size: 4vw;
            color: #7288a6;
        }
        li.active {
            font-size: 4.533vw;
            font-weight: bold;
            color: #111111;
            position: relative;
        }
        li:nth-child(n + 2) {
            margin-left: 5.867vw;
        }
        li.active::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 0.667vw;
            background: #71a209;
        }
    }
}
.select-bar {
    height: 12vw;
    background: #ffffff;
    border-bottom: solid 0.133vw #eeeeee;
    display: flex;
    justify-content: space-between;
}
.section-wrap {
    background: #ffffff;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    section {
        margin: 20px 20px 0 0;
        box-sizing: border-box;
        width: calc((100% - 60px) / 4);
        &:nth-child(4n) {
            margin-right: 0;
        }
        a {
            display: inline-block;
            text-decoration: none;
        }
        .img-wrap {
            width: 100%;
            height: 254px;
            border-radius: 4px;
            flex-shrink: 0;
            overflow: hidden;
            a {
                display: inline-block;
                text-decoration: none;
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                background: #f5f5f5;
                img {
                    max-width: 100%;
                    max-height: 100%;
                }
            }
        }
    }
}
.section-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .section-title {
        font-size: 16px;
        color: #12263f;
        line-height: 32px;
    }

    .section-museum {
        font-size: 14px;
        color: #7288a6;
    }
}
.tags {
    font-size: 12px;
    color: #ffffff;
    span {
        padding: 4px 8px !important;
        display: inline-block !important;
        border-radius: 2.67px !important;
        margin-right: 10px !important;
        &:nth-child(4n+1) {
            background: #7cb6f3;
        }
        &:nth-child(4n+2) {
            background: #e8b585;
        }
        &:nth-child(4n+3) {
            background: #95a7ff;
        }
        &:nth-child(4n+4) {
            background: #85e8a0;
        }
        &:last-child {
            margin-right: 0 !important;
        }
    }
}
.tip {
    font-size: 3.467vw;
    color: #9b9b9b;
    text-align: center;
    padding: 5.333vw 0 12vw 0;
}
</style>
<style lang="scss">
.inputs {
    .el-input__inner {
        width: 100%;
        height: 28px;
        border: none;
        padding: 0;
    }
}
.rightOpt {
    .el-select {
        margin-left: 10px;
        .el-input__inner {
            max-width: 125px;
            border-radius: 20px;
        }
    }
}
.tags {
    font-size: 12px;
    color: #ffffff;
    span {
        padding: 4px 8px;
        display: inline-block;
        border-radius: 2.67px;
        margin: 0 10px 10px 0;
        &:nth-child(4n+1) {
            background: #7cb6f3;
        }
        &:nth-child(4n+2) {
            background: #e8b585;
        }
        &:nth-child(4n+3) {
            background: #95a7ff;
        }
        &:nth-child(4n+4) {
            background: #85e8a0;
        }
        &:last-child {
            margin-right: 0;
        }
    }
}
</style>